import { shouldShowError } from './shouldShowError';
/**
 * Returns `true` if there is an error, and it should be shown to the user.
 * @param {WidgetProps} props - Widget props.
 * @returns {boolean} True in case of an error.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isErrorVisible(props) {
    if (shouldShowError(props)) {
        return props.internalData.error != null || props.error != null;
    }
    else {
        return false;
    }
}
